
export const Legends = () => {
  return (
    <div id='category'>
      <div className="row">
        <div className="col-xs-12 col-md-6">
          <div className="about-text">
            <h2>THE GREYHOUND LEGENDS</h2>
            <h4>This event will happen after the minting process. Every member of the society will be able to participate no matter the amount of greyhounds, everybody will have the same chances.</h4>
            <h4>In The Founder's adventure he had contact with 7 legendary greyhounds, 7 unique NFTs that don't share any trait with other greyhounds. The Founder wrote in his journal moments of his adventure and also some clues for future members of the society to search and own this legends.</h4>
          </div>
        </div>
        <div className="col-xs-12 col-md-6" style={{display: 'flex', justifyContent: 'center'}}>
          <img style={{width: 500}} src="./img/legends.jpg" className="img-responsive" alt="" />{" "}
        </div>
      </div>
    </div>
  )
}
